import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Selector } from '@leverege/ui-elements';
import { LabelGroup, Flex } from '../../views';
import style from './style.css'

const WhereFactory = require( './WhereFactory' )

class WhereLogicEditor extends React.Component {
  static TYPE = 'whereLogic'

  static propTypes = {
    disabled : PropTypes.bool,
    where : PropTypes.array.isRequired,
    onChange : PropTypes.func,
    index : PropTypes.number.isRequired,
    create : PropTypes.bool,
    aliasSuggestions : PropTypes.array
  };

  static defaultProps = {
    disabled : false,
    create : false,
    onChange : () => {},
    aliasSuggestions : []
  };

  static operators = [
    { description : 'or', symbol : 'or' },
    { description : 'and', symbol : 'and' }
  ]

  constructor( props, context ) {
    super( props, context )

    this.state = {
      newWhere : [ null, null, null ]
    }
  }

  onWhere = ( { index, item, action } ) => {
    const { query, queryName, where } = this.props
    const { newWhere } = this.state
    const { onChange, index : rootIndex } = this.props

    if ( action === 'delete' ) {
      const nWhere = [ where[0], [ ...( where[1] || [] ) ] ]
      nWhere[1].splice( index, 1 )
      return onChange( {
        index : rootIndex,
        item : nWhere
      } )
    }

    // TODO : CONDENSE
    if ( action === 'create' ) {
      const nWhere = [ where[0], [ ...( where[1] || [] ) ] ]
      nWhere[1].push( newWhere )
      this.setState( { newWhere : [ null, null, null ] } )
      return onChange( {
        index : rootIndex,
        item : nWhere
      } )
    }
    if ( action === 'createAnd' ) {
      const nWhere = [ where[0], [ ...( where[1] || [] ) ] ]
      nWhere[1].push( [ 'and', [ newWhere ] ] )
      this.setState( { newWhere : [ null, null, null ] } )  
      return onChange( {
        index : rootIndex,
        item : nWhere
      } )
    }
    if ( action === 'createOr' ) {
      const nWhere = [ where[0], [ ...( where[1] || [] ) ] ]
      nWhere[1].push( [ 'or', [ newWhere ] ] )
      this.setState( { newWhere : [ null, null, null ] } )  
      return onChange( {
        index : rootIndex,
        item : nWhere
      } )
    }

    if ( index === -1 ) {
      this.setState( { newWhere : item } )
    } else {
      const nWhere = [ where[0], [ ...( where[1] || [] ) ] ]
      nWhere[1][index] = item
      return onChange( {
        index : rootIndex,
        item : nWhere
      } )
    }
  }

  onDeleteGroup = () => {
    const { index, onChange } = this.props
    return onChange( {
      index,
      action : 'delete'
    } )
  }

  onChangeRootOperator = ( { value : symbol } ) => {
    const { onChange, index, where } = this.props
    onChange( { index, item : [ symbol, where[1] ] } )
  }

  render() {
    const { where, aliasSuggestions } = this.props
    const { newWhere } = this.state
    const [ operator, clauses ] = where

    const pathComponents = (
      clauses && clauses.map( ( where, index ) => {
        return WhereFactory.factory( where, { aliasSuggestions, key : typeof path === 'string' ? `${where}-${index}` : `${where[0]}-${index}`, index, onChange : this.onWhere } ) // <WhereEditor aliasSuggestions={whereSuggestions} key={typeof path === 'string' ? `${where}-${index}` : `${where[0]}-${index}`} where={where} index={index} onChange={onWhere} />
      } )
    ) || []

    pathComponents.push( WhereFactory.factory( newWhere, { aliasSuggestions, key : 'newWhere', index : -1, onChange : this.onWhere, create : true } ) ) // <WhereEditor aliasSuggestions={whereSuggestions} where={newWhere} key="newWhere" index={-1} onChange={onWhere} create /> )

    return (
      <div className={style.logicEditor}>
        <div className={style.logicHeader}>
          <Selector
            className={style.castDrop}
            valueKey="symbol"
            nameKey="symbol"
            values={WhereLogicEditor.operators}
            value={operator}
            onChange={this.onChangeRootOperator} />
          <Button bsStyle="link" className={style.button} onClick={this.onDeleteGroup}>
            <i className="fa fa-trash" />
          </Button>
        </div>
        <div className={style.clauses}>
          {pathComponents}
        </div>
      </div>
    )
  }
}

exports.WhereLogicEditor = WhereLogicEditor
